/*eslint-disable*/
import api from '../'

class searchGameApi {
    static getGroups (locale) {
        return api.axios.get('/search/groups', { params: { locale }}).then(response => response.data);
    }

    // GET: items
    static getItemsByRequest (params) {
        return api.axios.post('/search/items', params).then(response => response.data.items);
    }
}

export default searchGameApi;
